// extracted by mini-css-extract-plugin
export default {"advertDetailServiceList":"c-o_hc","advertDetailServiceList__header":"c-o_he","advertDetailServiceList__list":"c-o_hf"};